import { withLatestFrom, map } from 'rxjs/operators';
import { zefGo } from '@zerops/zef/ngrx-router';
import { Observable } from 'rxjs';
import { HashMap } from '@ngneat/transloco';
import { ActivatedRoute } from '@angular/router';

export const localSeachValueChangeRedirect = (
  activatedRoute: ActivatedRoute,
  routerParams$: Observable<HashMap<any>>
) => {
  const path = activatedRoute.pathFromRoot.reduce((arr, itm) => {
    const p = itm.snapshot?.url[0]?.path;
    if (p) { arr.push(p); }
    return arr;
  }, []);

  return function<T>(source: Observable<T>) {
    return source.pipe(
      withLatestFrom(routerParams$),
      map(([ search, params ]) => zefGo([
        ...path,
        { ...params, search }
      ]))
    );
  };
};
